import { createFileRoute } from '@tanstack/react-router';
import { InventarioListagem } from '@/features/inventario/page/listagem/InventarioListagem';

export const Route = createFileRoute('/a/inventario/')({
    component: InventarioListagem,
});
